import * as React from "react";
const SvgArrowDoubleDown20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m3.293 4.707 6 6 .707.707.707-.707 6-6-1.414-1.414L10 8.586 4.707 3.293 3.293 4.707Zm0 6 6 6 .707.707.707-.707 6-6-1.414-1.414L10 14.586 4.707 9.293l-1.414 1.414Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowDoubleDown20Px;
